import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useMemo } from 'react';
import { makeMsalFromConfig } from './makeMsalFromConfig';
import { MsalProvider } from '@azure/msal-react';
import { initializeAuth } from './initializeAuth';
import { useAppConfig } from '../appConfig';
import { authContext } from './authContext';
import { useMsrcMsalCallbackHandlerEffect } from './useMsrcMsalCallbackHandlerEffect';
import { useSSO } from './useSSO';
/** An auth provider which is meant to be wrapped around your application, and takes
 * an MSAL config, allowing children to access auth info via a useAuthData() hook.
 *
 * > Note: This is exposed to support custom scenarios.
 * > Most use cases should use AppConfigAndAuthProvider.
 */
export const AuthProvider = ({ children }) => {
    const config = useAppConfig();
    // Create our local instance of MSAL
    const msalApp = useMemo(() => {
        if (config) {
            const msalApp = makeMsalFromConfig(config);
            initializeAuth(msalApp);
            return msalApp;
        }
    }, [config]);
    if (!msalApp) {
        return null;
    }
    return (_jsx(MsalProvider, { instance: msalApp, children: _jsx(LocalAuthProvider, { children: children }) }));
};
const LocalAuthProvider = ({ children }) => {
    const [error, setError] = useState();
    const [errorSilent, setErrorSilent] = useState();
    const clearError = () => {
        setErrorSilent(undefined);
        setError(undefined);
    };
    // Try to sign in silently
    useSSO();
    const { isApiTokenLoaded } = useMsrcMsalCallbackHandlerEffect(setError, setErrorSilent);
    return (_jsx(authContext.Provider, { value: {
            acquireToken: () => {
                throw new Error('acquireToken should now be loaded via `const acquireToken = useAcquireToken`');
            },
            clearError,
            error,
            errorSilent,
            setError,
            setErrorSilent,
            isApiTokenLoaded,
        }, children: children }));
};
